// extracted by mini-css-extract-plugin
module.exports = {"redeem-amount":"_1fwYwDf4KE45zU3Owe_ePw"};